/* 🤖 this file was generated by script */
export const wiconStamp = {
  name: 'stamp',
  data: `<svg viewBox="0 0 20 21"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M4.5 14.5H3v-1c0-1.1.9-2 2-2h2.85c.6 0 1.08-.54 1-1.14A45.45 45.45 0 018.5 5.5c0-.18.04-.39.1-.58.19-.6.78-.92 1.4-.92v0c.62 0 1.21.33 1.4.92.06.2.1.4.1.58 0 1.6-.2 3.62-.35 4.86-.08.6.4 1.14 1 1.14H15a2 2 0 012 2v1h-1.5m-11 0V17h11v-2.5m-11 0h11"/></svg>`,
};
